import { render, staticRenderFns } from "./Metas.vue?vue&type=template&id=713d20cd&scoped=true&"
import script from "./Metas.vue?vue&type=script&lang=js&"
export * from "./Metas.vue?vue&type=script&lang=js&"
import style0 from "./Metas.vue?vue&type=style&index=0&id=713d20cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d20cd",
  null
  
)

export default component.exports